/**
 * @generated SignedSource<<26641e21d934ce3a86e0a5015cd628ad>>
 * @relayHash d7b62a86f9accb46472f06fd8f3f4e67
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d7b62a86f9accb46472f06fd8f3f4e67

import { ConcreteRequest } from 'relay-runtime';
export type addressDialogCountriesQuery$variables = {
  language: string;
};
export type addressDialogCountriesQuery$data = {
  readonly displayableCountries: ReadonlyArray<{
    readonly countryIsoCode2: string;
    readonly countryName: string;
    readonly id: string;
    readonly language: string;
  }>;
};
export type addressDialogCountriesQuery = {
  response: addressDialogCountriesQuery$data;
  variables: addressDialogCountriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "language",
        "variableName": "language"
      }
    ],
    "concreteType": "CountryLookupTranslation",
    "kind": "LinkedField",
    "name": "displayableCountries",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "language",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryIsoCode2",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addressDialogCountriesQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "addressDialogCountriesQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "d7b62a86f9accb46472f06fd8f3f4e67",
    "metadata": {},
    "name": "addressDialogCountriesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a4016ab534323b926791de1e41f6c3a2";

export default node;
